export const calculateTotals = (items, discount = 0, shipping = 0) => {
    const subTotal = items.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
    );

    const grandTotal =
        Number(subTotal) -
        Number(discount || 0) +
        Number(shipping || 0);

    return {
        subTotal,
        grandTotal,
    };
};